export default __webpack_public_path__ + "static/media/trianguloInvertidoAzulVazio.112c067a.png";